import {CreatePureFactSeasonCommand, Season} from '@6grain/masofa-monolith-api-client/crop-monitoring';
import {PolygonConverterUtil} from '@app/utils/polygon-converter.util';

export function formatSeasonDateOnly(dateString: string | null | undefined): string | null {
  if (!dateString) {
    return null;
  }
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return null;
  }
  return date.toISOString().split('T')[0];
}

type SeasonUpdateInput = Season & {
  polygon?: string;
  polygonJson?: string | null;
  rentalTermsId?: string;
  rentalStartDate?: string;
  rentalEndDate?: string;
  sourceCropId?: string | null;
  contourConfirmationDate?: string | null;
  source?: string | null;
};

export function buildSeasonUpdatePayload(
  data: SeasonUpdateInput,
  fallbackPolygonJson?: string | null,
): Season {
  const payload: SeasonUpdateInput = {
    ...data,
    harvestingDate: formatSeasonDateOnly(data?.harvestingDate),
    harvestingDatePlan: formatSeasonDateOnly(data?.harvestingDatePlan),
    plantingDate: formatSeasonDateOnly(data?.plantingDate),
    plantingDatePlan: formatSeasonDateOnly(data?.plantingDatePlan),
    seedVarietyId: data?.seedVarietyId,
    plannedVarietyId: data?.plannedVarietyId,
    plannedCropId: data?.plannedCropId,
    cropConfirmationSource: data?.cropConfirmationSource,
    cropConfirmationDate: formatSeasonDateOnly(data?.cropConfirmationDate),
    contourConfirmationDate: formatSeasonDateOnly(data?.contourConfirmationDate),
    source: data?.source,
    cropId: data?.cropId,
    governmentContractStartDate: formatSeasonDateOnly(data?.governmentContractStartDate),
    governmentContractEndDate: formatSeasonDateOnly(data?.governmentContractEndDate),
    yieldHaPlan: Number(data?.yieldHaPlan) || null,
    yieldHaFact: Number(data?.yieldHaFact) || null,
    yieldPlan: Number(data?.yieldPlan) || null,
    yieldFact: Number(data?.yieldFact) || null,
    fieldArea: Number(data?.fieldArea) || null,
    monitoring: Boolean(data?.monitoring),
    polygonJson: data.polygon || data.polygonJson || fallbackPolygonJson || undefined,
  };

  delete payload.polygon;
  delete (payload as {rentalStartDate?: string}).rentalStartDate;
  delete (payload as {rentalEndDate?: string}).rentalEndDate;
  delete (payload as {rentalTermsId?: string}).rentalTermsId;
  delete payload.sourceCropId;

  return payload;
}

export function buildCreatePureFactSeasonPayload(
  data: SeasonUpdateInput,
  fallbackPolygonJson?: string | null,
): CreatePureFactSeasonCommand | null {
  const polygonSource =
    data.polygon
    || data.polygonJson
    || fallbackPolygonJson
    || null;
  const coordinates = PolygonConverterUtil.polygonJsonToCoordinates(polygonSource);
  if (!data.fieldId || !coordinates.length) {
    return null;
  }

  return {
    fieldId: data.fieldId,
    cropId: data.cropId,
    polygonWkt: PolygonConverterUtil.latLngArrayToWKT(coordinates),
    plantingDate: formatSeasonDateOnly(data.plantingDate),
    harvestingDate: formatSeasonDateOnly(data.harvestingDate),
  };
}
